import { Components, Theme } from '@mui/material/styles';

export default function MuiInputBase(theme: Theme): Components['MuiInputBase'] {
  return {
    styleOverrides: {
      root: {
        fontFamily: theme.typography.fontFamily,
        fontWeight: 400,
        fontSize: '16px',
        lineHeight: '24px',
        letterSpacing: '0px',
      },
    },
  };
}
